import { createStyles } from 'antd-style'

export const useStyles = createStyles(({ token }) => ({
  listBullet: {
    width: 8,
    height: 8,
    borderRadius: '50%',
    display: 'inline-block'
  },

  chartTooltip: {
    color: token.colorTextLightSolid,
    backgroundColor: token.colorBgSpotlight,
    borderRadius: `${token.borderRadius}px`,
    padding: '12px'
  },

  tooltipText: {
    color: token.colorTextLightSolid
  },

  totalLabel: {
    textAlign: 'right'
  },

  tooltipName: {
    display: 'inline-block',
    maxWidth: 150,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    verticalAlign: 'middle'
  }
}))
